import { connect } from 'react-redux';
import type { Dispatch } from '@reduxjs/toolkit';

import { SortBy } from 'src/components/organisms/FilterMenu/components/SortBy';
import type { SortOptionValue } from 'src/components/organisms/FilterMenu/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectActiveSortOption } from 'src/redux/filter/selectors/selectors';
import { actions } from 'src/redux/filter/slice';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products/thunks/updateFilters';
import type { AppThunkDispatch } from 'src/redux/store';

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChangeSortOption: (value: SortOptionValue) => {
    dispatch(actions.changeSortOption(value));
    (dispatch as AppThunkDispatch)(updateFilters(UpdateFiltersActionType.SORT));
  },
});

export const mapStateToProps = (state: ReduxApplicationState) => ({
  activeSortOption: selectActiveSortOption(state),
  isLoading: state.products.isLoading,
  sortOptions: state.filter.sortOptions,
});

export const SortByContainer = connect(mapStateToProps, mapDispatchToProps)(SortBy);
